import { VisualSuper } from "./visual-super.component.js";

class IFrame extends VisualSuper {
  namespace = "visual:iframe";
}

const indexFrame = new IFrame();
export { IFrame, indexFrame as iFrame };
